<div
  [class.mobile-sidebar]="isMobile()"
  [class.mobile-open]="isMobile() && isOpen()"
  class="centaur-sidebar"
>
  <!-- Nav scroll area -->
  <div class="sidebar-scroll">
    <!-- Quick buttons -->
    @for (btn of quickButtons(); track btn.labelKey) {
    <app-sidebar-nav-btn
      [labelKey]="btn.labelKey"
      [icon]="btn.icon"
      [path]="btn.path"
      [isOpen]="isOpen()"
      [active]="isActive(btn.path)"
      (navClicked)="navigate($any($event))"
    />
    }

    <!-- Major Jobs -->
    <app-sidebar-nav-section
      [sectionIcon]="'pi-briefcase'"
      [sectionLabelKey]="'nav.majorJobs'"
      [items]="majorJobItems()"
      [isOpen]="isOpen()"
      [expanded]="majorExpanded()"
      [activePath]="currentPath()"
      (toggleSection)="toggleSection('major')"
      (navClicked)="navigate($any($event))"
    />

    <!-- Minor Jobs -->
    <app-sidebar-nav-section
      [sectionIcon]="'pi-wrench'"
      [sectionLabelKey]="'nav.minorJobs'"
      [items]="minorJobItems()"
      [isOpen]="isOpen()"
      [expanded]="minorExpanded()"
      [activePath]="currentPath()"
      (toggleSection)="toggleSection('minor')"
      (navClicked)="navigate($any($event))"
    />
  </div>

  <!-- Help pinned at bottom -->
  <app-sidebar-nav-btn
    [labelKey]="'nav.helpDashboard'"
    [icon]="'pi-question-circle'"
    [path]="'/help'"
    [isOpen]="isOpen()"
    [active]="isActive('/help')"
    (navClicked)="navigate($any($event))"
    class="sidebar-help-btn"
  />

  <!-- Resize handle (desktop only) -->
  @if (!isMobile() && isOpen()) {
  <div (mousedown)="startResize($event)" class="sidebar-resize-handle"></div>
  }

  <!-- Floating toggle (visible on sidebar hover, desktop only) -->
  @if (!isMobile()) {
  <button
    [title]="isOpen() ? 'Collapse sidebar' : 'Expand sidebar'"
    (click)="toggleSidebar.emit()"
    class="sidebar-toggle-floating"
  >
    <i class="pi pi-bars"></i>
  </button>
  }
</div>
